// Leadfeeder company identification (previously an inline script in index.html).
// Same tracker ID and same 2s-after-load deferral; now gated by the production
// host AND Business Visitor Identification consent.
import { isProductionHost } from './env';

const LEADFEEDER_ID = 'YEgkB8ld62y8ep3Z';
let loaded = false;

export function isLeadfeederLoaded() {
  return loaded;
}

export function initLeadfeeder() {
  if (loaded || typeof window === 'undefined' || !isProductionHost()) return;
  loaded = true;
  const inject = () => {
    const w = window as unknown as { ldfdr?: ((...a: unknown[]) => void) & { _q?: unknown[] } };
    w.ldfdr =
      w.ldfdr ||
      Object.assign(
        function (...args: unknown[]) {
          (w.ldfdr!._q = w.ldfdr!._q || []).push(args);
        },
        {} as { _q?: unknown[] }
      );
    const s = document.createElement('script');
    s.src = `https://sc.lfeeder.com/lftracker_v1_${LEADFEEDER_ID}.js`;
    s.async = true;
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(s, first);
  };
  if (document.readyState === 'complete') setTimeout(inject, 2000);
  else window.addEventListener('load', () => setTimeout(inject, 2000), { once: true });
}
